import BaseService from "./base";
import retry from "@/utils/retry";

class UserService extends BaseService {
    constructor(props) {
        super(props);
        this.baseUrl = this.options.baseUrl + '/tenant-users';
    }

    /**
     * @return Object with rows, totalPages, and totalRecords.
     * */
    async tenantUsers(params) {
        const url = this.baseUrl + `/users?${BaseService.getQueryString(params)}`;
        const requestPromise = this.get(url);
        return this.httpRequest(requestPromise).then(res => res.data);
    }

    async findUserByEmail(partialEmail) {
        const url = this.baseUrl + `/find-email?search=${partialEmail}`;
        const requestPromise = this.get(url);
        return this.httpRequest(requestPromise).then(res => res.data);
    }

    async tenantTeams() {
        const url = this.baseUrl + `/teams`;
        const requestPromise = this.get(url);
        return this.httpRequest(requestPromise).then(res => res.data);
    }

    async userInfo(body) {
        const url = this.baseUrl + `/user-info`;
        const requestPromise = this.post(url, body);
        return this.httpRequest(requestPromise);
    }

    async saveUserInfo(body) {
        const url = this.baseUrl + `/save-user-info`;
        const requestPromise = this.post(url, body);
        return this.httpRequest(requestPromise);
    }

    async archiveUser(body){
        const url = this.baseUrl + `/archive-user`;
        const requestPromise = this.post(url, body);
        return this.httpRequest(requestPromise);
    }
}

const getAccessToken = () => localStorage.getItem('token');
export const userService = new UserService({
    authToken: getAccessToken,
    refreshToken: retry,
    other: "",
    baseUrl: process.env.VUE_APP_API_URL
});